import { render } from "./LoadingSpin.vue?vue&type=template&id=f670782e"
import script from "./LoadingSpin.vue?vue&type=script&lang=js"
export * from "./LoadingSpin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__